export default __webpack_public_path__ + "static/media/bancs-2.74b21270.png";